import { useSyncExternalStore } from 'react';

import { mainModalSmallScreenMediaQuery } from './mainModalCompact.constants';

/**
 * Older WebKit (e.g. Safari &lt; 14) exposes only the legacy listener API on {@link MediaQueryList}.
 * Typed separately so we do not call deprecated DOM typings while still supporting those runtimes.
 */
type MediaQueryListLegacy = {
  addListener(callback: (event: MediaQueryListEvent) => void): void;
  removeListener(callback: (event: MediaQueryListEvent) => void): void;
};

function getBrowserWindow(): Window | undefined {
  return globalThis.window;
}

function subscribeLegacyMediaQueryChange(mql: MediaQueryList, onStoreChange: () => void) {
  const legacy = mql as unknown as MediaQueryListLegacy;
  const handler = () => onStoreChange();
  legacy.addListener(handler);
  return () => legacy.removeListener(handler);
}

function subscribe(onStoreChange: () => void) {
  const win = getBrowserWindow();
  if (!win?.matchMedia) {
    return () => undefined;
  }
  const mql = win.matchMedia(mainModalSmallScreenMediaQuery);
  if (mql.addEventListener !== undefined) {
    mql.addEventListener('change', onStoreChange);
    return () => mql.removeEventListener('change', onStoreChange);
  }
  return subscribeLegacyMediaQueryChange(mql, onStoreChange);
}

function getSnapshot() {
  const win = getBrowserWindow();
  if (!win?.matchMedia) {
    return false;
  }
  return win.matchMedia(mainModalSmallScreenMediaQuery).matches;
}

function getServerSnapshot() {
  return false;
}

/**
 * True when the viewport width is at or below the small-screen onboarding breakpoint.
 */
export function useMainModalSmallScreenLayout(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
